/* eslint-disable */
export default {
  ok: '确定',
} as const;

// @key: @#@"ok"@#@ @source: @#@"OK"@#@
